import { BsBell } from 'react-icons/bs';

import SectionCard from '#globalComponents/Card/SectionCard';
import Switch from '#globalComponents/Forms/Switch';

import { useSaveUserSettings } from '../../models/userSettings/mutations';
import { useUserSettings } from '../../models/userSettings/queries';

// Keys mirror the backend's NOTIFICATION_SETTINGS (services/mail/userNotification.js). Every flag is
// opt-out: a missing value means the mail is sent.
const NOTIFICATIONS = [
	{
		key: 'engagementReportEnabled',
		title: 'Täglicher Interaktionsbericht',
		description:
			'Einmal täglich um 7 Uhr: QR-Scans Ihrer Briefkampagnen und Link-Klicks Ihrer E-Mail-Kampagnen vom Vortag – nur an Tagen, an denen es etwas zu berichten gibt.',
	},
	{
		key: 'campaignStatusMailsEnabled',
		title: 'Status-Mails zu Briefkampagnen',
		description: 'Bestätigung, wenn eine Briefkampagne in Produktion geht und wenn alle Briefe bei der Post sind.',
	},
];

export const NotificationSettings = () => {
	const { data: settings } = useUserSettings();
	const save = useSaveUserSettings();
	const userSettings = settings?.userSettings ?? {};

	const handleToggle = (key, enabled) => {
		save.mutate({ updates: { userSettings: { ...userSettings, [key]: enabled } } });
	};

	return (
		<SectionCard
			title="E-Mail-Benachrichtigungen"
			subtitle="Welche Hinweise B2B Hero Ihnen per E-Mail schickt"
			icon={BsBell}
			bodyClassName="p-0 divide-y divide-bgBase-500"
		>
			{NOTIFICATIONS.map(({ key, title, description }) => (
				<div key={key} className="flex items-center justify-between gap-6 px-4 py-4">
					<div>
						<div className="text-sm font-medium text-text">{title}</div>
						<div className="text-xs text-bgBase-800 mt-0.5">{description}</div>
					</div>
					<Switch
						checked={userSettings[key] !== false}
						onChange={(enabled) => handleToggle(key, enabled)}
						disabled={!settings || save.isPending}
					/>
				</div>
			))}
		</SectionCard>
	);
};
